export const addDotTostring = (text: string, charLength: number) => {
  return text?.length < charLength
    ? text
    : text.substring(0, charLength) + '...';
};
